import React from "react";
import "./FaqModal.css";
import { Modal } from "react-bootstrap";
import Accordion from "./Accordion";

export const FaqModal = ({ openFaqModal, handleFaqModalClose }) => {
  let accordionData = [
    {
      title: "Why SmartFriends",
      content:
        "We believe that people are mentally dulled by watching superficial television and spending too much time on social media. To compensate this, it's good to stimulate your brain in a more challenging way.\n\nWith SmartFriends, you stimulate your brain every day, and most importantly: in a fun way! Why fun? Because you're doing it together with friends. That's how you stay motivated!",
    },
    {
      title: "Why only one challenge per day",
      content:
        "It should be fun. If you have to play many in a row, it can get boring. One a day is enough to put your brain to work.\n\nRemember, sometimes the challenges are really hard so it will take you a while.",
    },
    {
      title: "Where can I see the answer's explanation",
      content:
        "Every day we publish the explanation of yesterday's answer. Tomorrow you'll see today's answer when you click on the button 'yesterday' (in the menu). This way it's not possible to cheat 😊",
    },
    {
      title: "The images are too small, can I do something",
      content:
        "If you press or make the “zoom gesture” on the challenge image, a page with the zoomed image will be shown.",
    },
    {
      title: "What does a ☆ mean",
      content:
        "You see this in front of the challenge text if it's a real difficult one. If you're able to solve it, you must be a real genius!",
    },
  ];

  // if ( === true) {
  accordionData.push({
    title: "What's a Genius challenge?",
    content:
      "It's an extra difficult challenges. You can play them whenever you want, there's no time limit. Genius results do not affect your score.",
  });
  accordionData.push({
    title: "How do I get Genius challenges?",
    content:
      "ress the red dot in the top-right corner of the screen to get a genius challenge after watching a short ad",
  });

  // }

  const deviceLanguage = navigator.language;
  const languageOnly = deviceLanguage.split("-")[0];
  if (languageOnly === "nl") {
    accordionData = [
      {
        title: "Waarom SmartFriends",
        content:
          "Wij geloven dat mensen mentaal afgestompt raken door oppervlakkige televisie te kijken en te veel tijd door te brengen op sociale media. Om dit te compenseren is het goed om je hersenen op een meer uitdagende manier te stimuleren.\n\nMet SmartFriends stimuleer je je hersenen elke dag, en het belangrijkste: op een leuke manier! Waarom leuk? Omdat je het samen met vrienden doet. Zo blijf je gemotiveerd!",
      },
      {
        title: "Waarom maar 1 challenge per dag",
        content:
          "Het moet leuk zijn. Als je er veel achter elkaar moet spelen, kan het saai worden. 1 per dag is genoeg om je hersenen aan het werk te zetten.\n\nVergeet niet dat de challenges soms erg moeilijk zijn, dus het zal even duren.",
      },
      {
        title: "Waar kan ik de uitleg van het antwoord zien",
        content:
          "Elke dag publiceren we de uitleg van het antwoord van gisteren. Morgen zie je het antwoord van vandaag als je op de knop 'gisteren' klikt (in het menu).\n\nOp deze manier is het niet mogelijk om vals te spelen 😊",
      },
      {
        title: "De afbeeldingen zijn erg klein, kan ik hier iets aan doen",
        content:
          "Als je op de challenge afbeelding klikt of het 'zoomgebaar' maakt, wordt er een pagina met de ingezoomde afbeelding weergegeven.",
      },
      {
        title: "Wat betekent een ☆",
        content:
          "Je ziet dit voor de tekst van de challenge als deze echt moeilijk is. Als het lukt om deze op te lossen, ben je wel een echte genius!",
      },
    ];
  }

  return (
    <Modal
      centered
      animation={true}
      show={openFaqModal}
      onHide={handleFaqModalClose}
      className="faq-modal"
      loading="lazy"
    >
      <Modal.Header className="faq-header">
        <div className="faq-title">
          <span>
            {languageOnly === "nl"
              ? "Veelgestelde Vragen"
              : "Frequently Asked Questions"}
          </span>
        </div>
        <span onClick={handleFaqModalClose} className="close-button-faq">
          &times;
        </span>
      </Modal.Header>
      <Modal.Body className="faq-body">
        <div className="faq-body-content">
          {accordionData.map((item, index) => (
            <Accordion key={index} title={item.title} content={item.content} />
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};
